import { render, staticRenderFns } from "./ConfigResume.vue?vue&type=template&id=d2670404"
import script from "./ConfigResume.vue?vue&type=script&lang=js"
export * from "./ConfigResume.vue?vue&type=script&lang=js"
import style0 from "./ConfigResume.vue?vue&type=style&index=0&id=d2670404&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports